import React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

const CharmedSvg: React.FunctionComponent<BaseSvgProps> = ({
  className = "",
  fillColor,
  secondaryFillColor,
}) => {
  return (
    <BaseSvg className={className} viewBox="0 0 24 24">
      <path
        fill={fillColor}
        d="M15.7,12.4c0,0-0.1,0-0.1,0c0-0.1,0-0.1,0-0.2c0-4.3-3.2-7.8-7.2-7.8s-7.2,3.5-7.2,7.8c0,0.1,0,0.1,0,0.2    c-0.1,0-0.1,0-0.2,0c-0.6,0.2-0.8,1.1-0.5,2.1c0.3,1,1,1.6,1.6,1.5c0.2,0.4,0.4,0.8,0.7,1.1c0.5,2.9,2.8,5.8,5.6,5.8    c2.8,0,5.1-3,5.6-5.8c0.3-0.3,0.5-0.7,0.7-1.1c0.6,0.1,1.2-0.5,1.5-1.5C16.5,13.5,16.3,12.6,15.7,12.4z"
      />

      <path
        fill={secondaryFillColor}
        d="M8.4,1.3c0.3-0.3,0.6-0.6,1-0.8c1.3-0.5,2.8,0.3,3,1.5c0.1,0.5,0,1-0.4,1.5c-1.2,1.6-2.4,3.1-3.6,4.7    c0,0,0,0-0.1,0.1c0,0-0.1-0.1-0.1-0.1C7.2,6.7,6,5.1,4.8,3.6C3.9,2.4,4.5,0.7,6.1,0.4C7,0.3,7.7,0.5,8.3,1.2    C8.4,1.2,8.4,1.2,8.4,1.3z"
      />
      <path
        fill={fillColor}
        d="M8.4,8.8L8.2,8.5C8.1,8.5,8.1,8.4,8.1,8.4L7.3,7.5C6.4,6.3,5.4,5,4.5,3.8C4,3.2,3.9,2.3,4.2,1.6    c0.3-0.8,1-1.3,1.9-1.5C7-0.1,7.8,0.1,8.4,0.7C8.7,0.5,9,0.3,9.3,0.2c0.7-0.3,1.6-0.2,2.3,0.2c0.6,0.4,1.1,1,1.2,1.6    c0.1,0.6,0,1.2-0.5,1.8L8.4,8.8z M6.6,0.8c-0.1,0-0.3,0-0.4,0c-0.6,0.1-1.1,0.5-1.3,1C4.7,2.4,4.8,2.9,5.1,3.4C6,4.6,7,5.8,7.9,7    l0.5,0.7l3.4-4.4c0.3-0.4,0.4-0.8,0.3-1.2C12,1.7,11.7,1.3,11.3,1c-0.5-0.3-1.1-0.3-1.7-0.1C9.2,1,9,1.2,8.7,1.5L8.5,1.9L8,1.4    C7.6,1,7.2,0.8,6.6,0.8z"
      />
      <path
        fill={secondaryFillColor}
        d="M2.4,5.4C2.5,5.2,2.7,5.1,2.9,5c0.6-0.2,1.4,0.1,1.5,0.8c0,0.3,0,0.5-0.2,0.7C3.6,7.3,3,8,2.4,8.8    c0,0,0,0,0,0c0,0,0,0,0,0C1.8,8,1.2,7.3,0.6,6.5C0.1,5.9,0.5,5.1,1.2,5C1.7,4.9,2,5,2.4,5.4C2.3,5.3,2.4,5.4,2.4,5.4z"
      />
      <path
        fill={fillColor}
        d="M2.4,9.4L2,9L0.3,6.8C0,6.4-0.1,5.9,0.1,5.5C0.3,5,0.7,4.7,1.2,4.6c0.5-0.1,0.9,0,1.2,0.3    c0.1-0.1,0.2-0.2,0.4-0.2c0.4-0.2,0.9-0.1,1.3,0.1C4.4,5,4.7,5.3,4.8,5.7c0.1,0.4,0,0.7-0.3,1L2.4,9.4z M1.5,5.3    c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0.2-0.5,0.4c-0.1,0.2,0,0.4,0.1,0.6l1.5,1.9l1.5-2C4,6.1,4,6,4,5.8c0-0.2-0.1-0.3-0.3-0.4    C3.5,5.3,3.2,5.3,3,5.4C2.9,5.4,2.8,5.5,2.7,5.6L2.4,6L2.1,5.6C1.9,5.4,1.7,5.3,1.5,5.3z"
      />

      <path
        fill={secondaryFillColor}
        d="M14.4,5.4c0.1-0.2,0.3-0.3,0.5-0.4c0.6-0.2,1.4,0.1,1.5,0.8c0,0.3,0,0.5-0.2,0.7C15.6,7.3,15,8,14.4,8.8    c0,0,0,0,0,0c0,0,0,0,0,0c-0.6-0.8-1.2-1.5-1.8-2.3c-0.5-0.6-0.1-1.4,0.6-1.6C13.7,4.9,14,5,14.4,5.4C14.3,5.3,14.4,5.4,14.4,5.4z    "
      />
      <path
        fill={fillColor}
        d="M14.4,9.4L14,9l-1.8-2.3c-0.3-0.4-0.4-0.9-0.2-1.3c0.2-0.4,0.6-0.8,1.1-0.9c0.5-0.1,0.9,0,1.2,0.3    c0.1-0.1,0.2-0.2,0.4-0.2c0.4-0.2,0.9-0.1,1.3,0.1c0.4,0.2,0.6,0.6,0.7,0.9c0.1,0.4,0,0.7-0.3,1L14.4,9.4z M13.5,5.3    c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0.2-0.5,0.4c-0.1,0.2,0,0.4,0.1,0.6l1.5,1.9l1.5-2C16,6.1,16,6,16,5.8c0-0.2-0.1-0.3-0.3-0.4    c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0.1-0.3,0.1-0.3,0.3L14.4,6l-0.3-0.4C13.9,5.4,13.7,5.3,13.5,5.3z"
      />

      <path
        fill={secondaryFillColor}
        d="M11.2,15.1L11.2,15.1c0,1-0.2,1.7-0.7,2.2S9.4,18,8.6,18S7,17.7,6.4,17.2s-0.8-1.3-0.8-2.3v-2.5     c0-1,0.3-1.8,0.8-2.3s1.2-0.8,2-0.8c0.9,0,1.6,0.2,2.1,0.7s0.7,1.2,0.7,2.2l0,0H9.6c0-0.6-0.1-1-0.2-1.2s-0.5-0.4-0.9-0.4     c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.3,0.7-0.3,1.3v2.6c0,0.6,0.1,1,0.3,1.3c0.2,0.3,0.5,0.4,0.9,0.4c0.4,0,0.7-0.1,0.8-0.3     s0.2-0.6,0.2-1.2H11.2z"
      />
    </BaseSvg>
  );
};

export default CharmedSvg;
